import ProductService from '../../api/services/ProductService';

export const namespaced = true;

export const state = {
  loading: false,
  glowTagProducts: {},
  connectorProducts: {},
};

export const mutations = {
  SET_GLOW_TAG_PRODUCT(state, glowTagProducts) {
    state.glowTagProducts = glowTagProducts;
  },
  SET_CONNECTOR_PRODUCT(state, connectorProducts) {
    state.connectorProducts = connectorProducts;
  },
  LOADING(state, loading) {
    state.loading = loading;
  },
};

export const actions = {
  fetchGlowTagProduct({ commit, dispatch }) {
    commit('LOADING', true);
    ProductService.getProductByIDs([3284, 3290, 3291])
      .then((response) => {
        commit('SET_GLOW_TAG_PRODUCT', response);
        commit('LOADING', false);
      })
      .catch((error) => {
        commit('LOADING', false);
        commit('SET_GLOW_TAG_PRODUCT', {});
        error.location = 'fetchGlowTagProduct';
        dispatch(
          'notification/notifyFailure',
          { message: 'There was an error loading glow tag products.', options: { dismissSecs: 15 } },
          { root: true }
        );
      });
  },
  fetchConnectorProducts({ commit, dispatch }, { cityId }) {
    commit('LOADING', true);
    ProductService.getProductsByTypes(['CONNECTOR'], cityId)
      .then((response) => {
        commit('SET_CONNECTOR_PRODUCT', response?.['Connector_Products']);
        commit('LOADING', false);
      })
      .catch((error) => {
        commit('LOADING', false);
        commit('SET_CONNECTOR_PRODUCT', {});
        error.location = 'fetchConnectorProducts';
        dispatch(
          'notification/notifyFailure',
          { message: 'There was an error loading connector products.', options: { dismissSecs: 15 } },
          { root: true }
        );
      });
  },
};
